export default "__VITE_ASSET__BPcy6M7k__"